module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('rect', {
    staticClass: "border",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "rx": _vm.cellRadius,
      "width": _vm.cellWidth,
      "height": _vm.cellHeight
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "text",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "dx": _vm.txtDx,
      "dy": _vm.txtDy
    }
  }, [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0274c71c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HarmapHoleNumber.vue
// module id = 97
// module chunks = 1